import { useApiGet } from '../../shared/api/utils/reactQueryProvider';
import { getRideOverviewDetails } from '../api/services/Rides';
import { RideOverviewDetails } from '../types/rideOverview';

interface IUseRideOverviewQuery {
  rideSlug: string;
}

export const RIDE_OVERVIEW_QUERY_KEY = 'rideOverview';

export const useRideOverviewQuery = ({ rideSlug }: IUseRideOverviewQuery) => {
  // driver Details endpoint can be used to return the driver qualifications when ride is unclaimed
  return useApiGet<{ data: RideOverviewDetails }>(
    [RIDE_OVERVIEW_QUERY_KEY, rideSlug],
    () => getRideOverviewDetails(rideSlug),
    {
      enabled: true,
    }
  );
};
